<template>
  <section class="section" id="campos">
    <request-form :id="id"></request-form>
  </section>
</template>

<script>
import RequestForm from '@/components/admin/on-board/RequestForm.vue'

export default {
  components: { RequestForm },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style></style>
